import { GlobalToken } from 'antd';
import styled from 'styled-components';

interface EngineContainerProps {
  $hasFinishedWizard: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const EngineContainer = styled.div<EngineContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    margin-left: ${({ theme: { token } }) => token.marginXXL}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .flex-row {
    display: flex;
  }

  .steps {
    display: flex;
    flex-direction: column;

    .step-item {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme: { token } }) => token.marginXL}px;

      .circle {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
        width: 50px;
        height: 50px;
        border-radius: 50px;
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        color: ${({ theme: { token } }) => token.colorBorder};
        cursor: default;

        &.selected {
          color: ${({ theme: { token } }) => token.colorPrimary};
        }
      }

      .horizontal-link {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
        width: 13px;
        height: 14px;
        margin-left: -1px;
      }
    }
  }

  .card {
    width: 1032px;
    min-height: ${({ $hasFinishedWizard }: { $hasFinishedWizard: boolean }) =>
      $hasFinishedWizard ? '520px' : '611px'};
    background-color: ${({ theme: { token } }) => token.colorBgContainer};

    .ant-tabs {
      height: 100%;

      .ant-tabs-nav {
        margin: ${({ theme: { token } }) => token.marginLG}px ${({ theme: { token } }) => token.marginXL}px 0
          ${({ theme: { token } }) => token.marginXL}px;
      }

      .ant-tabs-content {
        height: 100%;

        .ant-tabs-tabpane {
          height: 100%;
        }
      }
    }
  }
`;
